"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uuid = void 0;
// uuid
function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}
/**
 * 基于伪随机数生成 **uuid**。
 */
function uuid() {
    // then to call it, plus stitch in '4' in the third group
    return (S4() + S4() + '-' + S4() + '-4' + S4().substr(0, 3) +
        '-' + S4() + '-' + S4() + S4() + S4()).toLowerCase();
}
exports.uuid = uuid;
//# sourceMappingURL=uuid.js.map